import { Guest } from "@/types/guest";
import { Hotel } from "@/types/hotel";
import { Room } from "@/types/room";
import { BookingGuest } from "@/types/booking-guest";

export interface Booking {
  id: string;
  guestId: string;
  hotelId: string;
  roomId: string;
  status: BookingStatus;
  totalAmount: number;
  specialRequests: string[];
  bookingNumber?: number;

  bookingSource?: string;
  preCheckinStatus: PreCheckStatus;
  preCheckoutStatus: PreCheckStatus;
  checkinStatus: CheckinStatus;
  checkoutStatus: CheckoutStatus;
  arrivalDate: Date;
  departureDate: Date;
  checkinMethod?: CheckinMethod;
  estimatedTimeOfArrival?: Date;
  preCheckinEnteredGuests?: number;
  checkinComments?: string;
  notes: string[];

  createdAt: Date;
  updatedAt: Date;

  room: Room;
  guest: Guest;
  additionalGuests?: BookingGuest[];
  hotel: Hotel;
}

export enum BookingStatus {
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  CHECKED_IN = "CHECKED_IN",
  CHECKED_OUT = "CHECKED_OUT",
  CANCELLED = "CANCELLED",
}

export enum CheckinStatus {
  DONE = "DONE",
  NOT_DONE = "NOT_DONE",
}

export enum CheckoutStatus {
  DONE = "DONE",
  NOT_DONE = "NOT_DONE",
}

export enum CheckinMethod {
  FLIGHT = "FLIGHT",
  CAR = "CAR",
  TRAIN = "TRAIN",
  BUS = "BUS",
  TAXI = "TAXI",
  WALK_IN = "WALK_IN",
  OTHER = "OTHER",
  INTERNAL_SERVICE = "INTERNAL_SERVICE",
  ACTIVITY = "ACTIVITY",
  AMENITY_SERVICE = "AMENITY_SERVICE",
}

export enum PreCheckStatus {
  DONE = "DONE",
  SENT = "SENT",
  SENT_3 = "SENT_3",
  SENT_7 = "SENT_7",
  NOT_DONE = "NOT_DONE",
  NOT_SEND = "NOT_SEND",
}
